<template>
  <div>
    <v-navigation-drawer
      v-if="smAndDown"
      theme="dark"
      v-model="localIsHamburgerOpen"
      absolute
      temporary
    >
      <v-list>
        <side-bar-link
          v-for="sidebarLink in props.sidebarLinks"
          :key="sidebarLink.name"
          :sidebar-link="sidebarLink"
        />
      </v-list>
      <template v-slot:append>
        <v-list>
          <side-bar-link
            v-for="lowerSidebarLink in props.lowerSidebarLinks"
            :key="lowerSidebarLink.name"
            :sidebar-link="lowerSidebarLink"
          />
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script setup lang="ts">
import SideBarLink from '@/layout/components/sidebar/SideBarLink.vue';
import { defineProps, defineEmits, ref, watch } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';

const props = defineProps<{
  sidebarLinks: SidebarLink[];
  lowerSidebarLinks: SidebarLink[];
  isHamburgerOpen: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:isHamburgerOpen', value: boolean): void;
}>();

const { smAndDown } = useDisplay();
const localIsHamburgerOpen = ref(false);

//Control sidebar
watch(localIsHamburgerOpen, () => {
  emit('update:isHamburgerOpen', false);
});
watch(
  () => props.isHamburgerOpen,
  () => {
    localIsHamburgerOpen.value = true;
  }
);
watch(smAndDown, () => {
  localIsHamburgerOpen.value = false;
});
</script>
